<template>
    <button class="actionButton" @click="doClick">
        <div class="mark">
            <IconBase><IconAdd /></IconBase>
        </div>
        <div class="txt">追加</div>
    </button>
</template>

<script>
import MopButtonMixin from "@/components/buttons/MopButtonMixin.vue";
import IconAdd from "@/components/icons/IconAdd.vue";

export default {
    name: "MopAddButton",
    mixins: [MopButtonMixin],
    components: {
        IconAdd
    }
};
</script>
